import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {removeItem, updateAll, updateObject} from '@/store/utils'
import {Tax, TaxesState, TaxesPayload, RegisterPaymentPayload} from './types'
export {TaxesState}

const initState: TaxesState = {
  autoManage: false,
  taxes: [],
  count: 0,
  amountTotal: 0,
  nextOffset: 0,
  paidTaxes: [],
  paidCount: 0,
  paidNextOffset: 0,
  tax: null as any,
}

const module: ModuleFc<TaxesState> = (ctx) => ({
  namespaced: true,
  state: cloneDeep(initState),
  actions: {
    async getTaxes({commit, rootState}, payload: TaxesPayload = {}) {
      const {
        kind = 'tax_pay',
        bizId = rootState.biz.id,
        order = 'dueDate',
        status = ['pending', 'failed', 'invalid', 'processing'],
        limit,
        offset,
      } = payload
      const result = await ctx.$axios({
        url: '/taxes',
        method: 'get',
        data: {
          bizId
        },
        params: {
          kind,
          status,
          order,
          limit,
          offset,
        },
      })
      commit('updateTaxes', {
        list: result.data.results,
        offset: result.data.nextOffset,
        count: result.data.count,
      })
    },
    async getPaidTaxes({commit, rootState, state}, payload: TaxesPayload = {}) {
      const {
        kind = 'tax_pay',
        bizId = rootState.biz.id,
        order = 'baseTime',
        status = ['completed'],
        limit = 10,
        offset = Number(state.paidNextOffset),
      } = payload
      const result = await ctx.$axios({
        url: '/taxes',
        method: 'get',
        data: {
          bizId,
        },
        params: {
          kind,
          status,
          order,
          limit,
          offset,
        },
      })

      commit('updatePaidTaxes', {
        list: result.data.results,
        offset: result.data.nextOffset,
        count: result.data.count,
      })
    },
    async getTax({commit, rootState}, payload: { id?: string, bizId?: string } = {}) {
      const {id} = payload
      const result = await ctx.$axios({
        url: '/taxes/$id',
        data: {
          id,
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
        },
        method: 'get',
      })
      commit('updateTax', result.data)
    },
    async registerPayment({rootState}, payload: RegisterPaymentPayload) {
      const {bizId = rootState.biz.id, taxIds, bank, password} = payload
      await ctx.$axios({
        url: '/register-payment',
        method: 'post',
        data: {
          bizId,
          taxIds,
          bank,
          password,
        },
      })
    },
    async updateTaxStatus({commit, rootState}, payload: {
      bizId?: string, id: string, status: string
    }) {
      const {bizId = rootState.biz.id, id, status} = payload
      const result = await ctx.$axios({
        url: '/taxes/$id/status',
        method: 'post',
        data: {
          bizId,
          id,
          status,
        },
      })
      commit('updateTax', result.data)
    },
    async getTaxSummary({commit, rootState}, payload: {bizId?: string, kind?: string} = {}) {
      const {bizId = rootState.biz.id, kind = 'tax_pay'} = payload
      const result = await ctx.$axios({
        url: '/taxes/summary',
        method: 'get',
        params: {bizId, kind},
      })
      commit('update', result.data)
    },
  },
  mutations: {
    update(state, payload: TaxesState) {
      updateObject(state, payload)
    },
    updateTaxes(state, payload: {list: Tax[], offset, count}) {
      updateAll(state.taxes, payload.list)
      state.nextOffset = payload.offset
      state.count = payload.count
    },
    updatePaidTaxes(state, payload: {list: Tax[], offset, count}) {
      updateAll(state.paidTaxes, payload.list)
      state.paidNextOffset = payload.offset
      state.paidCount = payload.count
    },
    remove(state, id: string) {
      removeItem(state.taxes, {id})
    },
    updateTax(state, payload: Tax) {
      state.tax = payload
    },
    clear(state) {
      updateObject(state, initState)
    },
    clearTax(state) {
      state.tax = initState.tax
    },
    clearTaxes(state) {
      state.taxes = []
      state.count = 0
      state.nextOffset = 0
    },
    clearPaidTaxes(state) {
      state.paidTaxes = []
      state.paidCount = 0
      state.paidNextOffset = 0
    }
  },
})

export default module
